import { render, staticRenderFns } from "./DealerUsersEdit.vue?vue&type=template&id=ab4f1028&scoped=true"
import script from "./DealerUsersEdit.vue?vue&type=script&lang=js"
export * from "./DealerUsersEdit.vue?vue&type=script&lang=js"
import style0 from "./DealerUsersEdit.vue?vue&type=style&index=0&id=ab4f1028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f1028",
  null
  
)

export default component.exports